import { BaseApiService } from "@mirage/services/BaseApiService";
import { ISavedSearchService } from "@shared/publicportal/services/ISavedSearchService";
import {
    DeleteSavedSearchRequest,
    DeleteSavedSearchResponse,
    UpdateSavedSearchRequest,
    UpdateSavedSearchResponse,
    GetSavedSearchResponse,
    ISavedSearch,
    CreateSavedSearchResponse,
} from "@shared/publicportal/contracts/ISavedSearch";

export default class SavedSearchService extends BaseApiService implements ISavedSearchService {
    constructor() {
        super("publicportal/savedsearches");
    }

    async getSearches(): Promise<GetSavedSearchResponse[]> {
        const response = await this.httpInstance().get("/");
        return response.data;
    }

    async createSavedSearch(request: Omit<ISavedSearch, "userId">): Promise<CreateSavedSearchResponse> {
        const response = await this.httpInstance().post("/", request);
        return response.data;
    }

    async updateSavedSearch(request: Omit<UpdateSavedSearchRequest, "userId">): Promise<UpdateSavedSearchResponse> {
        const response = await this.httpInstance().put(`/${request.id}`, request);
        return response.data;
    }

    async deleteSavedSearch(request: Omit<DeleteSavedSearchRequest, "userId">): Promise<DeleteSavedSearchResponse> {
        const response = await this.httpInstance().delete(`/${request.id}`);
        return response.data;
    }
}
